import React, { useState } from 'react';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ApartmentIcon from '@mui/icons-material/Apartment';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import Grid from './Grid';
import ReadinessCheckDialog from '../Communities/ReadinessCheckDialog';

const OnLive = ({
  removeOnLive,
  addOnLiveData,
  handleRemoveLive,
  apartmentData,
  open,
  closePop,
  onLiveSettings,
  tenantId
}) => {
  const [searchVal, setSearchVal] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [readinessCheckOpen, setReadinessCheckOpen] = useState(false);
  const apartmentDataLive =
    apartmentData && apartmentData.length
      ? apartmentData.filter(item => item.isLive && item.integrations)
      : [];

  const handleChange = val => {
    setSearchVal(val);
    setFilteredData(() => {
      const searchTerm = val.toLowerCase();
      const filtered = apartmentDataLive.filter(item =>
        item?.name?.toLowerCase().startsWith(searchTerm)
      );
      return filtered || [];
    });
  };

  const filteredLive = searchVal?.length ? filteredData : apartmentDataLive;

  const handleRemoveData = () => {
    closePop();
    handleRemoveLive();
  };

  const count =
    apartmentData?.filter(item => item?.integrations && item?.isLive).length ||
    0;

  return (
    <Dialog
      open={open}
      onClose={closePop}
      maxWidth="md"
      fullWidth
      sx={{ '& .MuiDialog-paper': { height: '80vh' } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 500, color: 'text.secondary' }}
        >
          Live Communities
        </Typography>
        <IconButton onClick={closePop} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: '16px'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <TextField
              onChange={e => handleChange(e.target.value)}
              placeholder="Search communities"
              variant="outlined"
              size="small"
              value={searchVal}
              sx={{ width: '250px' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: 'text.disabled' }} />
                  </InputAdornment>
                )
              }}
            />
            <Chip
              icon={<ApartmentIcon sx={{ fontSize: '16px' }} />}
              label={`${count} Communities`}
              size="small"
              color="primary"
              variant="outlined"
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '16px',
            minHeight: 0
          }}
        >
          {filteredLive && filteredLive.length ? (
            filteredLive.map(item => (
              <Grid
                tag={false}
                key={item?._id}
                apptId={item?._id}
                header={item.name}
                address={item.addressId}
                applySettingsData={addOnLiveData}
                removeOnboard={removeOnLive}
                isCLOProperty={item?.isCLOProperty}
              />
            ))
          ) : (
            <Typography sx={{ color: 'text.secondary', py: '40px' }}>
              No live communities available.
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: '24px', py: '16px', gap: '8px' }}>
        <Button
          variant="outlined"
          onClick={() => setReadinessCheckOpen(true)}
          disabled={!onLiveSettings?.length}
          startIcon={<FactCheckOutlinedIcon />}
        >
          Run Checks
        </Button>
        <Box sx={{ flex: 1 }} />
        <Button
          variant="contained"
          color="error"
          onClick={handleRemoveData}
          disabled={!onLiveSettings?.length}
        >
          Remove Selected
        </Button>
      </DialogActions>

      <ReadinessCheckDialog
        open={readinessCheckOpen}
        onClose={() => setReadinessCheckOpen(false)}
        mode="check"
        communityIds={onLiveSettings}
        communities={
          apartmentDataLive?.filter(c => onLiveSettings.includes(c._id)) || []
        }
        tenantId={tenantId}
      />
    </Dialog>
  );
};

export default OnLive;
